import { defineComponent as _defineComponent } from 'vue';
import LaunchApp from '@/shared/launchApp';
import { detectEnv } from '@/shared/detect';
import { reactive } from 'vue';
import { useRoute } from 'vue-router/composables';
import yxhTextSvg from '@/assets/img/yxh-text.svg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'launching',
    setup: function(__props) {
        var visibleMap = reactive({
            overlay: false
        });
        var route = useRoute();
        var launchApp = new LaunchApp({
            protocol: 'yixianghua',
            fallback: '/download-app',
            applinks: 'https://applinks.yxh2.cn'
        });
        if (detectEnv.wechat) {
            visibleMap.overlay = true;
        } else {
            launchApp.open(route.fullPath);
        }
        return {
            __sfc: true,
            visibleMap: visibleMap,
            route: route,
            launchApp: launchApp,
            yxhTextSvg: yxhTextSvg
        };
    }
});
